// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sheet-config-edit-caret[data-v-349f67c6]{color:#adb5bd}.sheet-config-edit-caret[data-v-349f67c6] :hover{color:#000}`, "",{"version":3,"sources":["<input css 14>"],"names":[],"mappings":"AAAA,0CAAyB,aAAa,CAAC,iDAAgC,UAAU","sourcesContent":[".sheet-config-edit-caret{color:#adb5bd}.sheet-config-edit-caret :hover{color:#000}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
